import React, { useRef } from "react";
import { agents, counties, propertyTypes } from "./filterOptions";
import { CURRENT_YEAR, DEFAULT_FILTERS, money } from "./propertyData";

export default function ActiveFilters({ filters, onRemove }) {
  const container = useRef(null);
  const chips = [];
  for (const [key, options, category] of [
    ["filterCounties", counties, "County"],
    ["filterPropertyTypes", propertyTypes, "Property type"],
    ["filterAgents", agents, "Agent"],
  ]) {
    for (const value of filters[key].filter((value) => value !== "all")) {
      const remaining = filters[key].filter((item) => item !== value);
      chips.push({
        key: `${key}-${value}`,
        label: options.find((option) => option.value === value)?.label || value,
        category,
        patch: { [key]: remaining.length ? remaining : ["all"] },
      });
    }
  }
  if (
    Number(filters.startYear) !== 2010 ||
    Number(filters.endYear) !== CURRENT_YEAR
  ) {
    chips.push({
      key: "years",
      category: "Years",
      label: `${filters.startYear}–${filters.endYear}`,
      patch: { startYear: 2010, endYear: CURRENT_YEAR },
    });
  }
  const min = Number(filters.minPrice),
    max = Number(filters.maxPrice);
  if (min !== 0 || max !== DEFAULT_FILTERS.maxPrice) {
    const label =
      min === 0
        ? `Up to ${money(max)}`
        : max === DEFAULT_FILTERS.maxPrice
        ? `At least ${money(min)}`
        : `${money(min)}–${money(max)}`;
    chips.push({
      key: "price",
      category: ["rentals", "shares"].includes(filters.dataOption)
        ? "Rent"
        : "Price",
      label,
      patch: { minPrice: 0, maxPrice: DEFAULT_FILTERS.maxPrice },
    });
  }
  const minBeds = Number(filters.minBeds),
    maxBeds = Number(filters.maxBeds);
  if (minBeds !== 0 || maxBeds !== DEFAULT_FILTERS.maxBeds) {
    const label =
      maxBeds === DEFAULT_FILTERS.maxBeds
        ? `${minBeds}+ beds`
        : minBeds === maxBeds
        ? `${minBeds} beds`
        : minBeds === 0
        ? `Up to ${maxBeds} beds`
        : `${minBeds}–${maxBeds} beds`;
    chips.push({
      key: "beds",
      category: "Bedrooms",
      label,
      patch: { minBeds: 0, maxBeds: DEFAULT_FILTERS.maxBeds },
    });
  }
  const remove = (patch) => {
    onRemove(patch);
    container.current?.focus();
  };
  return (
    <section
      className="active-filters"
      aria-label="Applied filters"
      ref={container}
      tabIndex="-1"
    >
      <span className="active-filters-label">Applied filters</span>
      {chips.length ? (
        <>
          <div className="filter-chips">
            {chips.map((chip) => (
              <button
                className="filter-chip"
                key={chip.key}
                title={`${chip.category}: ${chip.label}`}
                aria-label={`Remove ${chip.category.toLowerCase()} filter: ${
                  chip.label
                }`}
                onClick={() => remove(chip.patch)}
              >
                {chip.label}
                <span aria-hidden="true">×</span>
              </button>
            ))}
          </div>
          <button
            className="text-button clear-filters"
            onClick={() =>
              remove({
                filterCounties: ["all"],
                filterPropertyTypes: ["all"],
                filterAgents: ["all"],
                startYear: 2010,
                endYear: CURRENT_YEAR,
                minBeds: 0,
                maxBeds: DEFAULT_FILTERS.maxBeds,
                minPrice: 0,
                maxPrice: DEFAULT_FILTERS.maxPrice,
              })
            }
          >
            Clear all
          </button>
        </>
      ) : (
        <span className="muted">All years and prices · No filters applied</span>
      )}
    </section>
  );
}
